import axiosAPI from 'axios';

const axios = axiosAPI.create({
  baseURL: process.env.REACT_APP_99GIFT_ENDPOINT,
});

export { axios };
